// extracted by mini-css-extract-plugin
export default {"BoldLine":"VerificationCodeModal_BoldLine__vbkQ-","BigButton":"VerificationCodeModal_BigButton__C8u0M","ShortHeader":"VerificationCodeModal_ShortHeader__zUq8A"};